import { getStore } from '../store/store';

export default function getCountOfHiddenTopResults(): number {
    const { topResults, numberOfTopResultsShown } = getStore();
    const remainingTopResults = topResults?.slice(numberOfTopResultsShown);
    return remainingTopResults?.length || 0;
}
